module.exports = __webpack_public_path__ + "static/img_life_saving_gift_banner_4_m@2x-fdcd65abac73ba71ff3d0789dafb28a8.jpg";